import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';
const MODULE_NAME = 'Assembled Part';
const routes = [
    {
        matchRegex: '/AssembledPart/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail (Standard)'),
        slots: [
            SLOT_KEY.SLOT_V_SECTION,
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'page-action', label: 'Page Action' },
                { key: 'assembled-part-form', label: 'Assembled Part Form' },
                { key: 'page-container', label: 'Page Container' },
            ],
        },
    },
]
export default routes;